/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';
export const createGenericSlice = (name, initialState) => {
    return createSlice({
        name: name,
        initialState,
        reducers: {
            fetch(state, action) {
                console.log(action);
                state.loading = true;
            },
            fetchSuccess(state, action) {
                console.log(action);
                state.loading = false;
                state.response = action.payload;
            },
            fetchFailed(state, action) {
                console.log(action);
                state.loading = false;
                state.error = true;
            },
            resetReducer(state, action) {
                console.log(action);
                const stateData = { ...state };
                stateData.loading = initialState.loading;
                stateData.error = initialState.error;
                stateData.response = initialState.response;
            },
        },
    });
};
